export default __webpack_public_path__ + "static/media/HemachandraS_Resume.5dd20de5.pdf";